export interface AppConfig {
  storyRegionDomain: string;
}

// story domains are stable per region, so hardcoded here instead of fetched from the config API
const storyRegionDomainsByRegion: Record<string, string> = {
  dev: "https://stories.electricshuffle.com",
  uk: "https://stories.electricshuffle.com",
  usa: "https://stories.electricshuffleusa.com",
};

export const getConfig = (): Promise<AppConfig> => {
  const region = process.env.REACT_APP_REGION ?? "";
  return Promise.resolve({ storyRegionDomain: storyRegionDomainsByRegion[region] ?? "" });
};
